import { clamp } from '../core/math';

/* 砲塔迴轉的角速度硬上限 —— 支柱二（機甲感來自上下半身分離，而分離必須有代價）
   在 M3 退場之後唯一保留的實現手段。

   熱量系統原本要承擔這條支柱，但 2026-08-01 的實測判定退場（見 03-ROADMAP.md 的
   M3 判定紀錄）。留下來的是這個 —— 它同樣讓「我面向哪裡」變成要管理的事，
   但**沒有任何一條需要盯的儀表**，不產生作業感與心理負擔。

   用硬上限而不是 damp，是因為 damp 是指數趨近，永遠有一個「大部分轉完了」的
   瞬間，玩家感覺不到限制；硬上限會讓「背後有東西」變成一個可以被計算的
   0.82 秒（180° ÷ 220°/秒），玩家因此會主動預轉砲塔 —— 那正是機甲操作的樣子。

   已知取捨：近距離高速目標會脫鎖。突刺者衝鋒（29.9 單位/秒）在 4 單位外掠過
   需要 428°/秒才追得上，砲塔追不到。若實測時「衝鋒後打不到」變成常態挫折，
   事前訂好的放寬值是 360°/秒。 */

const D2R = Math.PI / 180;

export var TURRET = { rate: 220 * D2R };

export function turnTurret(want, dt) {
  var cap = TURRET.rate * dt;
  return clamp(want, -cap, cap);
}
